export const FAQsection = () => {
    const faqItems = [
        {
            question: "What exactly is Project Unfinished?",
            answer: "Project Unfinished is a platform where creators can share their unfinished projects and find collaborators to bring them to completion. Whether you're an artist, developer, or writer, you can connect with like-minded individuals who share your passion for creativity."
          },
          {
            question: "What happens if I fill the form?",
            answer: "once you let us know your preferences, we'll subsequently match you up with projects and/or collaborators that will fit your work, with regular updates dropping in your inbox." }
    ];
  
    return (
      <div className="flex flex-col text-center items-center space-y-4 tracking-tighter lowercase">
        <h3 className="text-pretty text-4xl leading-tight font-semibold tracking-tighter mb-4 md:text-6xl">
          the long version.
        </h3>
        <div className="text-pretty text-base text-white/70 font-light font-nunito space-y-4 max-w-xl">
          {faqItems.map((item, index) => (
            <div key={index}>
              <p className="font-inter text-xl md:text-3xl font-semibold text-white/20">{item.question}</p>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
        <button 
            className="w-fit px-4 py-2 bg-white/10 text-white/70 rounded-lg font-nunito font-light"
            onClick={() => document.getElementById('form-content').scrollIntoView({ behavior: 'smooth' })}
          >
            <p className="text-base">get started</p>
          </button>
      </div>
    );
  };
  
